import { render, staticRenderFns } from "./AppointmentsPlugin.vue?vue&type=template&id=6496cba7&scoped=true&"
import script from "./AppointmentsPlugin.vue?vue&type=script&lang=ts&"
export * from "./AppointmentsPlugin.vue?vue&type=script&lang=ts&"
import style0 from "./AppointmentsPlugin.vue?vue&type=style&index=0&id=6496cba7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6496cba7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VCard,VCardTitle,VDivider})
